/** 公告 iframe：补全链接属性，并在 load 后绑定点击（绕过 sandbox 内导航限制） */

export const NOTICE_IFRAME_SANDBOX =
  'allow-same-origin allow-popups allow-popups-to-escape-sandbox allow-top-navigation-by-user-activation'

export const enhanceNoticeLinks = (html) => {
  if (!html) return ''
  return html.replace(/<a\b([^>]*?)>/gi, (match, attrs) => {
    let next = attrs
    if (!/target\s*=/i.test(next)) next += ' target="_blank"'
    if (!/rel\s*=/i.test(next)) next += ' rel="noopener noreferrer"'
    return `<a${next}>`
  })
}

export const buildNoticeSrcdoc = (html) => {
  const body = enhanceNoticeLinks(html || '')
  return `<!DOCTYPE html><html><head><meta charset="utf-8"><meta name="viewport" content="width=device-width,initial-scale=1"><style>*{margin:0;padding:0;box-sizing:border-box}html,body{font-family:"KaiTi",serif;font-weight:700;color:#222;text-align:center;line-height:1.6;overflow:hidden}img{max-width:100%;height:auto}a{color:#7b5cff;text-decoration:underline;cursor:pointer}</style></head><body>${body}</body></html>`
}

export const bindNoticeIframeLinks = (iframe) => {
  if (!iframe?.contentDocument) return
  try {
    iframe.contentDocument.querySelectorAll('a[href]').forEach((a) => {
      if (a.dataset.noticeBound === '1') return
      a.dataset.noticeBound = '1'
      if (!a.getAttribute('target')) a.setAttribute('target', '_blank')
      if (!a.getAttribute('rel')) a.setAttribute('rel', 'noopener noreferrer')
      a.addEventListener('click', (e) => {
        e.preventDefault()
        window.open(a.href, '_blank', 'noopener,noreferrer')
      })
    })
  } catch (_) { /* ignore */ }
}

export const resizeNoticeIframeEl = (iframe) => {
  if (!iframe) return
  try {
    bindNoticeIframeLinks(iframe)
    iframe.style.height = '0px'
    const h = iframe.contentDocument.documentElement.scrollHeight
    iframe.style.height = h + 'px'
  } catch (_) { /* cross-origin */ }
}
